export default {
  title: '元宇宙ID選擇',
  txt1: '您通過其他活動獲得了新的ID號碼，新獲得的ID號碼將為您保留14天，快選擇其中 1 個作為您的專屬身份ID吧！',
  btnTxt1: '使用該ID號碼',
  card1: '“500萬用戶的數智世界”活動獲得',
  card2: '入駐MyLink元宇宙獲得',
  card3: '入駐日期',
  popupTxt1: '確認使用該ID號碼？',
  popupTxt2: '您選擇的ID號碼將作為您在MyLink元宇宙的專屬元宇宙ID，您確定繼續嗎？',
  popupTxt3: '確認',
  popupTxt4: '我再想想',
  isNewLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/New_acquisition_fan.png',
  isUseLabel:
    'https://mylink.oss-accelerate.aliyuncs.com/mylinkH5/identity/identity/using_fan.png',
  toastTxt1: 'ID號碼更換成功',
  toastTxt2: '沒有可連接網絡，請重試'
}
